
export const gameServerLink = "https://uat.api.app.bigcitytrade.bigcityvoucher.co.in/v1/game/";
 